module.exports = __webpack_public_path__ + "img/story010@2x.6d4b59dd.webp";